import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initCartLineItemQty from '../components/cart-line-item-qty';
import initCartLineItemWarranty from '../components/cart-line-item-warranty';
import initRelatedProducts from '../sections/product/related-products';

ready(() => {
  initCartLineItemQty();
  initCartLineItemWarranty();
  initRelatedProducts();
});

onShopifySectionLoad(() => {
  initCartLineItemQty();
  initCartLineItemWarranty();
  initRelatedProducts();
});
